// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressSidebar__inner___Xx7p0{position:-webkit-sticky;position:sticky;top:96px}.PressSidebar__date___nC_o2{color:#c0beb8;font-weight:700;text-transform:uppercase}.PressSidebar__title___3kufX{color:inherit;font-weight:500;font-size:40px;line-height:56px;margin-top:8px;font-weight:200}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"inner": "PressSidebar__inner___Xx7p0",
	"date": "PressSidebar__date___nC_o2",
	"title": "PressSidebar__title___3kufX"
};
module.exports = ___CSS_LOADER_EXPORT___;
